export default function isEmpty(content) {
  const emptyStrings = ['', '<p></p>', '<p></p> ', '<p></p> \n', '<p></p>\n'];

  return Array.isArray(content) ? content.length === 0 : content !== null && emptyStrings.includes(content);
}
